module.exports = __webpack_public_path__ + "static/media/logo.ee5c73ea.png";